import { render, staticRenderFns } from "./ed-course-create-file-object.vue?vue&type=template&id=3f1326d8&"
import script from "./ed-course-create-file-object.ts?vue&type=script&lang=ts&"
export * from "./ed-course-create-file-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-create-file-object.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports